<mat-dialog-content>
 <emli-table-inner-content></emli-table-inner-content>
</mat-dialog-content>
